import React, { lazy } from 'react';
// project imports
import Loadable from '../components/common/lodable/Loadable';
import MainLayout from '../layout/MainLayout';
import { Navigate } from 'react-router-dom';

// HomePage option 3 routing
const ServiceLevel = Loadable(
  lazy(() => import('../pages/setup/serviceLevel/ServiceLevel'))
);
const Warranty = Loadable(
  lazy(() => import('../pages/setup/warranty/Warranty'))
);
const ERPProducts = Loadable(
  lazy(() => import('../pages/setup/erpProduct/ErpProductSearch'))
);
const HomePage = Loadable(lazy(() => import('../pages/home/Home')));
const Contracts = Loadable(
  lazy(() => import('../pages/entitlement/contracts/Contracts'))
);
const PriceBook = Loadable(
  lazy(() => import('../pages/setup/priceBook/PriceBook'))
);
const ETrackSettings = Loadable(
  lazy(() => import('../pages/setup/eTrackSettings/ETrackSettings'))
);
const OOSBillSets = Loadable(
  lazy(() => import('../pages/setup/oosBillSets/OosBillSets'))
);
const Customers = Loadable(
  lazy(() => import('../pages/entitlement/customers/Customers'))
);
const ErpSalesOrder = Loadable(
  lazy(() => import('../pages/entitlement/erpSalesOrder/ErpSalesOrder'))
);
const ManualOrder = Loadable(
  lazy(() =>
    import('../pages/entitlement/erpSalesOrder/manualOrder/ManualOrder')
  )
);
const StagingOrder = Loadable(
  lazy(() =>
    import('../pages/entitlement/erpSalesOrder/stagingOrder/StagingOrder')
  )
);
const Sites = Loadable(
  lazy(() => import('../pages/entitlement/sites-layout/Sites'))
);
const SiteInfo = Loadable(
  lazy(() => import('../pages/entitlement/sites-layout/siteInfo/SiteInfo'))
);
const SiteActivityDetail = Loadable(
  lazy(() =>
    import(
      '../pages/entitlement/sites-layout/siteActivityDetail/SiteActivityDetail'
    )
  )
);
const Entitlements = Loadable(
  lazy(() => import('../pages/entitlement/entitlements/Entitlements'))
);
const OutOfScopeCases = Loadable(
  lazy(() => import('../pages/entitlement/outOfScopeCases/OutOfScopeCases'))
);
const OutOfScopeBatchUpdate = Loadable(
  lazy(() =>
    import('../pages/entitlement/outOfScopeCases/batchUpdate/BatchUpdate')
  )
);
const ErpSalesOrderItems = Loadable(
  lazy(() =>
    import('../pages/entitlement/erpSalesOrderItems/ErpSalesOrderItems')
  )
);
const ExistingQuotes = Loadable(
  lazy(() => import('../pages/eTrack/existingQuotes/ExistingQuotes'))
);
const ExistingQuoteDetail = Loadable(
  lazy(() => import('../pages/eTrack/existingQuotes/quoteDetail/QuoteDetail'))
);
const QuoteApproval = Loadable(
  lazy(() => import('../pages/eTrack/quoteApproval/QuoteApproval'))
);
const QuoteApprovalDetail = Loadable(
  lazy(() => import('../pages/eTrack/quoteApproval/quoteDetail/QuoteDetail'))
);
const BillingTool = Loadable(
  lazy(() => import('../pages/billing/billingTool/BillingTool'))
);

const EmBilling = Loadable(
  lazy(() => import('../pages/billing/billingTool/EmBillingPage'))
);
const CpiSetup = Loadable(
  lazy(() => import('../pages/billing/cpiSetup/CpiSetup'))
);
const AdminScreenRoles = Loadable(
  lazy(() => import('../pages/useSetup/adminScreenRoles/AdminScreenRolesPage'))
);
const ETrackUserMCNMapping = Loadable(
  lazy(() =>
    import('../pages/useSetup/eTrackUserMCNMapping/ETrackUserMCNMappingPage')
  )
);
const ETrack = Loadable(lazy(() => import('../pages/eTrack/ETrack')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticatedRoutes = [
  {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        path: '/',
        element: <Navigate to="/home" replace />,
      },
      {
        path: '/home',
        allowed: true,
        element: <HomePage />,
      },
      {
        path: 'entitlement',
        allowed: true,
        children: [
          {
            path: 'Contracts',
            element: <Contracts />,
            featureName: 'ContractManagement',
          },
          {
            path: 'Customers',
            element: <Customers />,
            featureName: 'ContractManagement',
          },
          {
            path: 'Sites',
            element: <Sites />,
            featureName: 'ContractManagement',
          },
          {
            path: 'Sites/:id',
            element: <SiteInfo />,
            featureName: 'ContractManagement',
          },
          {
            path: 'Sites/sitedetails/:id',
            element: <SiteActivityDetail />,
            featureName: 'ContractManagement',
          },
          {
            path: 'OutOfScopeCases',
            element: <OutOfScopeCases />,
            featureName: 'OOS',
          },
          {
            path: 'OutOfScopeCases/:id',
            element: <OutOfScopeCases />,
            featureName: 'OOS',
          },
          {
            path: 'OutOfScopeCases/batch-update',
            element: <OutOfScopeBatchUpdate />,
            featureName: 'OOS',
          },
          {
            path: 'ErpSalesOrderItems',
            element: <ErpSalesOrderItems />,
            featureName: 'ContractManagement',
          },
          {
            path: 'Entitlements',
            element: <Entitlements />,
            featureName: 'EntitlementManagement',
          },
          {
            path: 'ErpSalesOrder',
            element: <ErpSalesOrder />,
            featureName: 'ContractManagement',
          },
          {
            path: 'Sites',
            element: <Sites />,
            featureName: 'ContractManagement',
          },
          {
            path: 'ErpSalesOrder/manual',
            element: <ManualOrder />,
            featureName: 'ContractManagement',
          },
          {
            path: 'ErpSalesOrder/staging',
            element: <StagingOrder />,
            featureName: 'ContractManagement',
          },
        ],
      },
      {
        path: 'etrack',
        allowed: true,
        children: [
          {
            path: 'existing-quotes',
            element: <ExistingQuotes />,
            featureName: 'eTrackInternal',
          },
          {
            path: 'existing-quotes/:id',
            element: <ExistingQuoteDetail />,
            featureName: 'eTrackInternal',
          },
          {
            path: 'quote-approval',
            element: <QuoteApproval />,
            featureName: 'eTrackInternal',
          },
          {
            path: 'quote-approval/:id',
            element: <QuoteApprovalDetail />,
            featureName: 'eTrackInternal',
          },
          {
            index: true,
            path: '/etrack',
            element: <ETrack />,
            featureName: 'eTrackInternal',
          },
        ],
      },
      {
        path: 'billing',
        allowed: false,
        children: [
          {
            path: '/billing/BillingTool',
            element: <EmBilling />,
            featureName: 'Billing',
          },
          {
            path: '/billing/BillingTool/EmBillingPage',
            element: <BillingTool />,
            featureName: 'Billing',
          },
          {
            path: 'cpiSetup',
            element: <CpiSetup />,
            featureName: 'Billing',
          },
        ],
      },
      {
        path: 'setup',
        allowed: true,
        children: [
          {
            path: 'EM-TrackSettings',
            element: <ETrackSettings />,
            featureName: 'EMSetup',
          },
          {
            path: 'ERPProducts',
            element: <ERPProducts />,
            featureName: 'EMSetup',
          },
          {
            path: 'OOSBillSets',
            element: <OOSBillSets />,
            featureName: 'EMSetup',
          },
          {
            path: 'PriceBook',
            element: <PriceBook />,
            featureName: 'EMSetup',
          },
          {
            path: 'ServiceLevels',
            element: <ServiceLevel />,
            featureName: 'EMSetup',
          },
          {
            path: 'Warranties',
            element: <Warranty />,
            featureName: 'EMSetup',
          },
        ],
      },
      {
        path: 'userSetup',
        allowed: true,
        children: [
          {
            path: 'AdminScreenRoles',
            element: <AdminScreenRoles />,
            featureName: 'Administrator',
          },
          {
            path: 'ETrackUserMCNMapping',
            element: <ETrackUserMCNMapping />,
            featureName: 'Administrator',
          },
        ],
      },
      {
        path: '*',
        element: <Navigate to="/" replace />,
      },
    ],
  },
];

export default AuthenticatedRoutes;
